import React from 'react';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import Switcher from '../Elements/Switcher';

class Footer extends React.Component {
    render() {
        const { t } = this.props;
        return (
            <>
                <footer className="site-footer footer-large footer-dark footer-wide bg-dark text-white">
                    {/* FOOTER BLOCKS START */}
                    <div className="footer-top overlay-wraper">
                        <div className="overlay-main" />
                        <div className="container">
                            <div className="footer-split">
                                {/* IZQUIERDA: marca + llamado a la acción */}
                                <div className="footer-split-left">
                                    <div className="widget widget_about text-white">
                                        <div className="logo-footer clearfix p-b5">
                                            <NavLink to={"./"}>
                                                <img src={require('../../images/soltarc-footer-logo.png')} alt="copra-landing-page" />
                                            </NavLink>
                                        </div>
                                        <ul className="social-icons sx-social-links footer-social">
                                            <li><a href="https://www.facebook.com/profile.php?id=61591009217655" className="fa fa-facebook social-fb" target="_blank" rel="noopener noreferrer" aria-label="Facebook" title="Facebook"></a></li>
                                            <li><a href="https://www.instagram.com/solt.arc?igsh=MWx3ZnRieHhjZW41Yw==" className="fa fa-instagram social-ig" target="_blank" rel="noopener noreferrer" aria-label="Instagram" title="Instagram"></a></li>
                                            <li><a href="https://www.linkedin.com/company/129914064/admin/dashboard/" className="fa fa-linkedin social-in" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" title="LinkedIn"></a></li>
                                        </ul>
                                    </div>
                                </div>

                                {/* DERECHA: enlaces + contacto + botón */}
                                <div className="footer-split-right">
                                    <div className="footer-right-cols">
                                        <div className="widget widget_services inline-links text-white">
                                            <h5 className="widget-title">{t('pages.footer.aboutUs.title')}</h5>
                                            <ul>
                                                <li><NavLink to={"/acerca-de"} className="text-white">{t('pages.footer.aboutUs.about')}</NavLink></li>
                                                <li><NavLink to={"/services"} className="text-white">{t('pages.footer.aboutUs.services')}</NavLink></li>
                                                <li><NavLink to={"/contact-us"} className="text-white">{t('pages.footer.aboutUs.contact')}</NavLink></li>
                                            </ul>
                                        </div>
                                        <div className="widget widget_address_outer text-white">
                                            <h5 className="widget-title">{t('pages.footer.contact.title')}</h5>
                                            <ul className="widget_address">
                                                <li>{t('pages.footer.contact.regions')}</li>
                                                <li>customer-service@soltarc.com</li>
                                                {/* <li>(+52) 55-879-12364</li> */}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="footer-cta-btn">
                                        <a href="/contact-us" className="site-button text-white">
                                            <i className="fa fa-paper-plane-o" /> {t('pages.footer.cta.button')}
                                        </a>
                                    </div>
                                    <div className="footer-cta text-white">
                                        <h5 className="text-uppercase m-b10 m-t0">{t('pages.footer.cta.heading')}</h5>
                                        <span>{t('pages.footer.cta.subheading')}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* FOOTER COPYRIGHT */}
                    <div className="footer-bottom overlay-wraper text-center text-white">
                    <div className="overlay-main" />
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <ul className="footer-links list-inline">
                                    <li className="list-inline-item"><NavLink to={"/declaracion-de-privacidad"} className="text-white">{t('pages.footer.links.privacy')} </NavLink> |</li>
                                    <li className="list-inline-item"><NavLink to={"/terminos-y-condiciones"} className="text-white">{t('pages.footer.links.terms')} </NavLink> |</li>
                                    <li className="list-inline-item"><NavLink to={"/aviso-legal"} className="text-white">{t('pages.footer.links.legal')} </NavLink> |</li>
                                    <li className="list-inline-item"><NavLink to={"/accesibilidad"} className="text-white">{t('pages.footer.links.accessibility')} </NavLink> |</li>
                                    <li className="list-inline-item"><NavLink to={"/politica-de-cookies"} className="text-white">{t('pages.footer.links.cookies')} </NavLink> |</li>
                                    <li className="list-inline-item"><NavLink to={"/politica-de-redes-sociales"} className="text-white">{t('pages.footer.links.socialMedia')} </NavLink> |</li>
                                </ul>
                                <div className="mt-3">
                                    <span className="copyrights-text"> {t('pages.footer.copyright')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </footer>
                <Switcher />
            </>
        );
    }
}

export default withTranslation()(Footer);
